export default [
  {
    path: "/payments/transaction",
    name: "PaymentsTransaction",
    component: () => import("@/views/Ondemand/Payments/Transactions.vue"),
  },
  {
    path: "/payments",
    name: "Payments",
    component: () => import("@/views/Ondemand/Payments/Payments.vue"),
  },
  {
    path: "/payments/cards",
    name: "Cards",
    component: () => import("@/views/Ondemand/Payments/Cards.vue"),
  },
  {
    path: "/payments/wallet",
    name: "Wallet",
    component: () => import("@/views/Ondemand/Payments/Wallet.vue"),
  },
  {
    path: "/payments/account-statement/:name",
    name: "AccountStatement",
    component: () => import("@/views/Ondemand/Payments/AccountStatement.vue"),
  },
  {
    path: "/payments/all-wallet",
    name: "AllWallet",
    component: () => import("@/views/Ondemand/Payments/AllWallet.vue"),
  },
];

